module.exports = __webpack_public_path__ + "img/nyyjs-3.f3d495f5.jpg";